<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'account'">
            <div class="page-header">
                <h3 class="page-title">Источники</h3>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
                    <b-btn size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                           v-b-modal.createSource>
                        Создать источник
                        <!--<i class="icon-fa icon-fa-pencil"></i>-->
                    </b-btn>
                </div>
              <div class="col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" v-if="!isMobile">
                <b-button-group class="filterComponent" style="width: 100%!important;">
                  <b-button variant="success" class="mr-1" v-on:click="selectAll"
                            size="sm">
                    <i class="icon-fa icon-fa-check-square-o"></i>
                  </b-button>
                  <b-button variant="danger" class="mr-1" v-on:click="diselectAll"
                            size="sm">
                    <i class="icon-fa icon-fa-close"></i>
                  </b-button>
                  <b-button variant="primary" class="mr-1" v-on:click="editSelected()"
                            size="sm">
                    <i class="icon-fa icon-fa-edit"></i>
                  </b-button>
                </b-button-group>
              </div>
              <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
                <b-button variant="warning" size="sm">
                  <a
                      v-bind:href="getExcelParamsString()">
                    Выгрузить xls <i class="icon-fa icon-fa-upload"></i>
                  </a>
                </b-button>
              </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <b-form-input placeholder="Поиск:"
                                  size="sm"
                                  class="filterComponent"
                                  v-model="search"></b-form-input>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <b-form-select v-model="user"
                                   size="sm"
                                   class="filterComponent"
                                   :options="users">
                        <option :value="null" disabled>Создатель</option>
                    </b-form-select>
                </div>
              <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <b-form-select v-model="responsibleBuyer"
                               size="sm"
                               class="filterComponent"
                               :options="activeUsers">
                  <option :value="null" disabled>Ответственный МБ</option>
                </b-form-select>
              </div>
                <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <v-select :options="groups" required v-model="group"
                              class="filterComponent groupComponent"
                              placeholder="Группа"
                              multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>

                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-button-group :key="dateRange" v-if="isXl" class="datePickerXl filterComponent">
                        <date-range-picker
                                ref="picker"
                                :locale-data="dateRangeLocalFormat"
                                v-model="range"
                                :opens="'center'"
                                :ranges="dateRanges"
                                @update="selectRange($event)">
                            <template v-slot:input="picker" style="min-width: 350px;!important;">
                                {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
                            </template>
                        </date-range-picker>
                        <b-button size="sm" variant="primary">
                            <i class="icon-fa icon-fa-calendar-check-o"></i>
                        </b-button>
                    </b-button-group>

                    <b-input-group :key="dateRange" v-if="!isXl" class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <datepicker input-class="form-control dateFrom"
                                        class="date dateLeft"
                                        size="sm"
                                        monday-first
                                        v-model="range.startDate"
                                        :language="ru"
                                        placeholder="С:">
                            </datepicker>
                            <datepicker input-class="form-control dateTo"
                                        class="date dateRight"
                                        monday-first
                                        size="sm"
                                        v-model="range.endDate"
                                        :language="ru"
                                        placeholder="По:">
                            </datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="myOffers col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-form-checkbox value="on"
                                     style="display: inline !important;"
                                     class="onlyMyCheckbox filterComponent"
                                     v-model="onlyMy">
                        Мои источники
                    </b-form-checkbox>
                </div>
                <div class="col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2 applyButton">
                    <b-input-group class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <b-btn size="sm" text="Search" variant="success"
                                   class="mainButton"
                                   style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                                   @click="getSources(1, {sortBy: sortBy, sortDesc: sortDesc}, search, user)">
                                Применить
                                <!--<i class="icon-fa icon-fa-search"></i>-->
                            </b-btn>
                            <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                                <!--<i class="icon-fa icon-fa-times"></i>-->
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="!isMobile">
                        <b-table hover responsive bordered
                                 small
                                 selectable
                                 ref="selectableTable"
                                 @row-clicked="rowClickHandler"
                                 :items="sources"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getSources(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                          <template v-slot:cell(responsible_buyer)="row">
                            <div>{{ row.item.responsible_buyer ? row.item.responsible_buyer.name : null }}</div>
                          </template>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-warning"
                                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin' || $currentUser.role == 'leader'"
                                          @click.stop="edit(row)">
                                    <i class="icon-fa icon-fa-edit"></i>
                                </b-button>
                                <b-button size="sm" class="btn btn-danger"
                                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin' || $currentUser.role == 'leader'"
                                          @click.stop="deleteSource(row.item)">
                                    <i class="icon-fa icon-fa-trash-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="isMobile">
                        <b-table hover responsive bordered stacked
                                 small
                                 :items="sources"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getSources(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                          <template v-slot:cell(responsible_buyer)="row">
                            <div>{{ row.item.responsible_buyer ? row.item.responsible_buyer.name : null }}</div>
                          </template>
                            <template v-slot:cell(user_id)="row">
                                <div>{{row.item.user.name}}</div>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" class="btn btn-warning"
                                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin' || $currentUser.role == 'leader'"
                                          @click.stop="edit(row)">
                                    <i class="icon-fa icon-fa-edit"></i>
                                </b-button>
                                <b-button size="sm" class="btn btn-danger"
                                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin' || $currentUser.role == 'leader'"
                                          @click.stop="deleteSource(row.item)">
                                    <i class="icon-fa icon-fa-trash-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5">
                    <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
                </div>
                <div class="col-sm-7">
                    <div class="float-right">
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center">
                                <b-pagination size="sm" :total-rows="pager.total"
                                              v-model="pager.current_page"
                                              v-on:change="getSources($event, {sortBy: sortBy, sortDesc: sortDesc}, search)"
                                              :per-page="pager.per_page"></b-pagination>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <b-modal id="createSource"
                     :no-close-on-backdrop="true"
                     :no-enforce-focus="true"
                     :no-close-on-esc="true"
                     ref="sourceCreateModal" size="md" title="Создать источник" @hidden="hideCreateModal"
                     hide-footer>
                <CreateSourceModal></CreateSourceModal>
            </b-modal>

            <b-modal ref="sourceEditModal"
                     :no-close-on-backdrop="true"
                     :no-enforce-focus="true"
                     :no-close-on-esc="true"
                     id="sourceEditModal" size="md" title="Редактировать источник" hide-footer>
                <EditSourceModal v-bind:source="selectedSource"></EditSourceModal>
            </b-modal>

          <b-modal ref="MassUpdateSourcesModal"
                   :no-close-on-backdrop="true"
                   :no-enforce-focus="true"
                   :no-close-on-esc="true"
                   @hide="getSources()"
                   id="MassUpdateSourcesModal" size="md" title="Редактировать источники" hide-footer>
            <MassUpdateSourcesModal v-bind:sources="selectedSources"></MassUpdateSourcesModal>
          </b-modal>
        </div>
    </div>
</template>
<script>
    import CreateSourceModal from './modals/CreateSourceModal.vue'
    import OffersService from '../../services/offersDataService'
    import EditSourceModal from './modals/EditSourceModal.vue'
    import SourcesService from '../../services/sourcesDataService'
    import {ru} from '../../services/customLocaleDatepicker'
    import Datepicker from 'vuejs-datepicker'
    import saveFiltersMixin from "./mixins/saveFiltersMixin";
    import DateRangePicker from 'vue2-daterange-picker'

    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";
    import MassUpdateSourcesModal from "./modals/MassUpdateSourcesModal.vue";
    import UsersService from "../../services/usersDataService";
    import Ls from "../../services/ls";

    export default {
        name: 'sources',
        components: {
            MassUpdateSourcesModal: MassUpdateSourcesModal,
            CreateSourceModal: CreateSourceModal,
            EditSourceModal: EditSourceModal,
            Datepicker: Datepicker,
            DateRangePicker: DateRangePicker
        },
        mixins: [
            saveFiltersMixin,
            vue2DateRangePickerMixin
        ],
        data() {
            return {
                sources: [],
                groups: [],
                group: [],
                pager: {},
                user: null,
                responsibleBuyer: null,
                users: [],
                onlyMy: false,
                pageSize: 50,
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true
                    },
                    {
                        key: 'title',
                        label: 'Название',
                        sortable: true
                    },
                    {
                        key: 'group',
                        label: 'Группа',
                        sortable: true
                    },
                    {
                      key: 'responsible_buyer',
                      label: 'Ответственный МБ',
                      sortable: true
                    },
                    {
                        key: 'user_name',
                        label: 'Создатель',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Дата создания',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: 'Действия',
                        tdAttr: {'align': "center"}
                    }
                ],
                search: '',
                sortBy: 'created_at',
                sortDesc: true,
                sortDirection: 'desc',
                savedFiltersName: 'sources',
                selectedSource: null,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                isXl: false,
                ru: ru,
                selectedSources: {},
                activeUsers: []
            }
        },
        methods: {
            getSources(page, sort, search, user) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        page = filters.page
                        sort = filters.sort

                        this.search = filters.search
                        this.range = this.dateConvert(filters.rangeStart, filters.rangeEnd)
                        this.user = filters.user
                        this.pageSize = filters.pageSize
                        this.group = filters.group
                        this.responsibleBuyer = filters.responsibleBuyer
                    }
                }

                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }
                let range = {
                    endDate: null,
                    startDate: null
                };

                range.endDate = this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : null;
                range.startDate = this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : null;

                if (!search) {
                    search = this.search ? this.search : null
                }
                if (!user) {
                    user = this.user
                }

                if (this.onlyMy) {
                    user = this.$currentUser.id;
                }

                if (this.isMobile) {
                    this.pageSize = 10;
                }

                let filtersObject = {
                    page: page,
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    search: search,
                    rangeStart: range.startDate,
                    rangeEnd: range.endDate,
                    user: user,
                    group: this.group,
                    pageSize: this.pageSize,
                    responsibleBuyer:  this.responsibleBuyer
                }

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                SourcesService.getSources(page, sort, search, range, user, this.responsibleBuyer, false, this.group, this.pageSize)
                    .then(sources => {
                        this.useSavedFilters = false
                        this.pager = sources;
                        this.sources = sources.data
                    })

            },
          rowClickHandler(row, index) {
            if (this.$refs.selectableTable.isRowSelected(index)) {
              // this.$refs.selectableTable.unselectRow(index)
              this.selectedSources[row.id] = false
              return
            }

            // this.$refs.selectableTable.selectRow(index)
            this.selectedSources[row.id] = true
          },
          selectAll() {
            this.isSelectAll = true

            this.sources.forEach((row, index) => {
              this.$refs.selectableTable.selectRow(index)
              this.selectedSources[row.id] = true
            })
          },
          diselectAll() {
            this.isSelectAll = false
            this.$refs.selectableTable.clearSelected()

            this.sources.forEach(function (item) {
              this.selectedSources[item.id] = false
            }.bind(this))
          },
          editSelected() {
            this.$refs.MassUpdateSourcesModal.show()
          },
            selectRange(event) {
                this.range = event;
            },
            resetFilters() {
                this.search = '';
                this.sortBy = 'updated_at';
                this.sortDesc = true;
                this.sortDirection = 'desc';
                this.user = null;
                this.responsibleBuyer = null;
                this.range = {
                    startDate: null,
                    endDate: null
                };
                this.group = [];
                this.onlyMy = false;
                //re-initialize element
                this.dateRange++;

                this.getSources();
            },
            getUsers() {
                OffersService.getUsers()
                    .then(users => {
                        let usersArray = [];

                        users.forEach(function (userItem) {
                            let user = {};
                            user.value = userItem.id;
                            user.text = userItem.name;
                            usersArray.push(user);
                        });

                        this.users = usersArray
                    })
            },
            edit(item) {
                this.selectedSource = item
                this.$refs.sourceEditModal.show()
            },
            deleteSource(source) {
              this.$bvModal.msgBoxConfirm('ID: ' + source.id + ' Название: ' + source.title , {
                title: 'Вы точно уверены, что хотите удалить?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ДА',
                cancelTitle: 'НЕТ',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
              })
                .then(value => {
                  if(value !== true) {
                    return
                  }

                  if(! confirm('Точно удаляем?')) {
                    return;
                  }
                  SourcesService.deleteSource(source.id)
                    .then(response => {
                      if (response.success) {
                        this.getSources();

                        toastr.success('Источник удалён!')
                      } else {
                        toastr.error('Вы не можете удалить этот источник. К нему привязаны данные.')
                      }
                    })
                })
                .catch(err => {
                })
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 415) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }

                if (this.window.width > 1199) {
                    this.isXl = true
                } else {
                    this.isXl = false
                }
            },
            hideCreateModal() {
                this.getSources();

                this.$refs.sourceCreateModal.hide()
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            getActiveUsers() {
              UsersService.getActiveUsers()
                .then(function (users) {
                  let usersArray = [];

                  users.forEach(function (userItem) {
                    let user = {};
                    user.value = userItem.id;
                    user.text = userItem.name;
                    usersArray.push(user);
                  });

                  this.activeUsers = usersArray;
                }.bind(this))
            },
          getExcelParamsString() {
            let params = {
              token: Ls.get('auth.token'),
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
              search: this.search,
              user: this.onlyMy ? this.$currentUser.id : this.user,
              responsibleBuyer: this.responsibleBuyer,
              group: this.group,
              start: this.range.startDate,
              end: this.range.endDate,
            }

            return '/sources/export?' + new URLSearchParams(params).toString();
          },
        },
        beforeMount() {
            this.useSavedFilters = true

            this.getSources()
            this.getUsers()
            this.getGroups();
            this.getActiveUsers();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }

    .popover-body {
        max-height: 200px;
        overflow: scroll;
    }

    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }

    .filterComponent {
        height: 30px !important;
    }

    .filterComponent .vs__dropdown-toggle {
        height: 30px !important;
    }

    .filterComponent .input-date {
        height: 30px !important;
    }

    .filterComponent .dateFrom {
        height: 30px !important;
    }

    .filterComponent .dateTo {
        height: 30px !important;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .myOffers {
        padding-top: 4px;
    }

    .groupComponent .vs__selected {
        margin: 2px 2px 4px 0 !important;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }
    .reportrange-text {
        font-size: 0.9rem;
        min-width: 150px;
        height: 30px !important;
        width: 110%!important;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.76666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.46666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 8.66666667% !important;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/front/Sources.vue